export default __webpack_public_path__ + "static/media/arduino.12bd73ca.jpg";